<div style="width: 25px;height: 25px;float: right;position: relative;right: -10px;cursor: pointer;"
     (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
<div class="page-body-wrapper">
    <form [formGroup]="lookupForm" (ngSubmit)="createOrUpdateLookup()">

        <div class="form-group">
            <label class="radio-group-label" id="isParentExist">Ana(parent) lookup var mı?</label>
            <mat-radio-group class="horizontal-radio-group"
                             aria-labelledby="isParentExist" [(ngModel)]="isParentExist" [ngModelOptions]="{standalone: true}">
                <mat-radio-button class="parentexist-radio-button" value="1">Evet</mat-radio-button>
                <mat-radio-button class="parentexist-radio-button" value="0" [checked]="true" >Hayır</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-group" *ngIf="isParentExist == '1'">
            <mat-form-field class="lookup-form-field">
                <input type="text" placeholder="Ana Lookup Seçiniz" aria-label="Number" formControlName="parent" matInput [matAutocomplete]="auto">
                <mat-error *ngIf="lookupForm.controls['parent'].hasError('required')">Ana lookup seçiniz</mat-error>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let lookup of filteredLookupList | async" [value]="lookup">
                        {{lookup.lookupCode}} - {{lookup.lookupValue}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div class="form-group">
            <mat-form-field class="lookup-form-field">
                <input matInput placeholder="Kod" formControlName="lookupCode" style="width: 250px;">
                <mat-error *ngIf="lookupForm.controls['lookupCode'].hasError('required')">Kod girmelisiniz</mat-error>
            </mat-form-field>
        </div>

        <div class="form-group">
            <mat-form-field class="lookup-form-field">
                <input matInput placeholder="Değer" formControlName="lookupValue">
                <mat-error *ngIf="lookupForm.controls['lookupValue'].hasError('required')">Değer girmelisiniz</mat-error>
            </mat-form-field>
        </div>

        <div class="form-group">
            <mat-form-field class="lookup-form-field">
                <textarea style="height: 150px;resize: none;width: 400px;" matInput class="form-control" formControlName="description"
                          id="description" aria-describedby="description" placeholder="Açıklama"></textarea>
                <mat-error *ngIf="lookupForm.controls['description'].hasError('required')">İçerik girilmeli</mat-error>
            </mat-form-field>
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="!lookupForm.valid">{{submitButtonName}}</button>
    </form>
</div>
